export * from './lib/tag-input.module';
export * from './lib/components/tag-input/tag-input.component';



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/angular2-tag-input/index.ts